import { render, staticRenderFns } from "./DetalleGrupoTeacher.vue?vue&type=template&id=dfb7ac84&scoped=true"
import script from "./DetalleGrupoTeacher.vue?vue&type=script&lang=js"
export * from "./DetalleGrupoTeacher.vue?vue&type=script&lang=js"
import style0 from "./DetalleGrupoTeacher.vue?vue&type=style&index=0&id=dfb7ac84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb7ac84",
  null
  
)

export default component.exports